import { FiscalType } from '../../enums/fiscalTypeEnum'

export const getFiscalFullName = (
  fiscalType: string,
  countryRegistration: string
) => {
  const ft = Number(fiscalType)
  return {
    label: {
      eng: ft === FiscalType.IP ? 'Full name IP*' : 'Company name*',
      rus: ft === FiscalType.IP ? 'Полное наименование ИП*' : 'Название компании*',
      kz: ft === FiscalType.IP
        ? 'Толық аты IP*'
        : ft === FiscalType.JSC
        ? 'Толық аты АҚ*'
        : ft === FiscalType.PJSC || ft === FiscalType.CJSC
        ? 'Толық аты ЖАҚ*'
        : ft === FiscalType.OsOO
        ? 'Толық аты ЖШС*'
        : 'Толық аты ЖШС*',
    },
    placeholder: {
      eng: ft === FiscalType.IP
        ? countryRegistration === '417' ? 'IP «Lastochka»' : 'IP «London industrial company»'
        : ft === FiscalType.JSC
        ? countryRegistration === '417' ? 'JSC «Almaty Industrial Company»' : 'JSC «London industrial company»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '417' ? 'PJSC «Almaty Industrial Company»' : 'PJSC «London industrial company»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '417' ? 'CJSC «Almaty Industrial Company»' : 'CJSC «London industrial company»'
        : ft === FiscalType.OsOO
        ? countryRegistration === '417' ? 'LLP «Almaty Industrial Company»' : 'LLP «London industrial company»'
        : 'LLC «London industrial company»',
      rus: ft === FiscalType.IP
        ? countryRegistration === '417' ? 'ИП «Ласточка»' : 'ИП «Московская промышленная компания»'
        : ft === FiscalType.JSC
        ? countryRegistration === '417' ? 'АО «Алматинская промышленная компания»' : 'АО «Московская промышленная компания»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '417' ? 'ПАО «Алматинская промышленная компания»' : 'ПАО «Московская промышленная компания»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '417' ? 'ЗАО «Алматинская промышленная компания»' : 'ЗАО «Московская промышленная компания»'
        : ft === FiscalType.OsOO && countryRegistration === '417'
        ? 'ОсОО «Алматинская промышленная компания»'
        : 'ООО «Московская промышленная компания»',
      kz: ft === FiscalType.IP
        ? countryRegistration === '417' ? 'IP «Martïn»' : 'IP «Мәскеу өнеркәсіптік компаниясы»'
        : ft === FiscalType.JSC
        ? countryRegistration === '417' ? 'АҚ «Алматы өнеркәсіп кәсіпорны»' : 'АҚ «Мәскеу өнеркәсіптік компаниясы»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '417' ? 'ЖАҚ «Алматы өнеркәсіп кәсіпорны»' : 'ЖАҚ «Мәскеу өнеркәсіптік компаниясы»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '417' ? 'ЖАҚ «Алматы өнеркәсіп кәсіпорны»' : 'ЖАҚ «Мәскеу өнеркәсіптік компаниясы»'
        : ft === FiscalType.OsOO
        ? countryRegistration === '417' ? 'ЖШС «Алматы өнеркәсіп кәсіпорны»' : '(ЖШС «Мәскеу өнеркәсіптік компаниясы»'
        : 'ЖШС «Мәскеу өнеркәсіптік компаниясы»',
    },
    invalidText: {
      eng: 'Enter the name correctly',
      rus: 'Введите наименование корректно',
      kz: 'Атын дұрыс енгізіңіз',
    },
  }
}
